import React from "react";
import "./CardTitle.scss"

export interface CardTitleProps {
    title?: any;
    value?: any;
    cancelTotalAmount?: boolean;
    color?: any;
    
}
 
export interface CardTitleState {
    
}
 
class CardTitle extends React.Component<CardTitleProps, CardTitleState> {
    constructor(props: CardTitleProps) {
        super(props);
        this.state = {  };
    }
    render() { 
        return ( 
            <div className="card-title">
                    <p style={{color: this.props.color}}>{this.props.title}</p>
                    {this.props.cancelTotalAmount ?
                    (<p className="cancel-totalamount">$--</p>)
                    :
                    (
                    <p className="title-amount">{this.props.value}</p>
                    )}
                    
                </div>
         );
    }
}
 
export default CardTitle;